import { Chip } from "@mui/material";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import moment from "moment";
import { useParams, useHistory } from "react-router-dom";
import { loadMembershipAction } from "redux/reducers/membership";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";

export default function MembershipCard(props) {
  const { list, tp } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  let { cd } = useParams();

  const isDday = (date) => {
    return checkDday(date) > -1;
  };

  const checkDday = (date) => {
    const today = moment(moment().format("YYYYMMDD"));
    const start = moment(date);
    return date ? today.diff(start, "days") : 0;
  };

  const getDday = (start, end) => {
    if (isDday(start)) {
      return `종료 D${checkDday(end) > 0 ? "+" : (checkDday(end) == 0 ? "-":"")}${checkDday(end)}`;
    } else {
      return `오픈 D${checkDday(start) > 0 ? "+" : ""}${checkDday(start)}`;
    }
  };

  const goDetail = () => {
    history.push(`/membership/${item.cd}`);
  };

  return (
    <ul>
      {list.map((item, i) => (
        <li
          className={
            item.optgTp != "2" || isDday(item.optgStrtYmd) && !(checkDday(item.optgEndYmd) > 0) ? "list-item-on" : "list-item-off"
          }
          onClick={() => {
            if (item.optgTp != "2" || isDday(item.optgStrtYmd) && !(checkDday(item.optgEndYmd) > 0)) {
              dispatch(loadAction({ back: true, title: item.nm, menu: false }));
              // dispatch(init());
              history.push(`/membership/${item.cd}`);
            }
          }}
          key={i}
        >
          <div className="contents">
            <div className="image">
              <LazyCDNImage
                cdnUrl={item.imgUrl}
                style={{
                  width: "52px",
                  height: "52px",
                  borderRadius: "50%",
                }}
              />
            </div>

            <div className="tit-wrap">
              <div className="tit">
                {item.nm} {tp == "join" && <Chip label="MY" color="primary" />}
              </div>
              {isDday(item.optgStrtYmd) ? (
                <span>
                  {item.desc} {isDday(item.optgStrtYmd)}
                </span>
              ) : (
                <span>
                  {item.optgTp == "2" ? (
                    <>오픈일 {moment(item.optgStrtYmd).format("MM.DD")}</>
                  ) : (
                    <>기간제한 없음</>
                  )}
                </span>
              )}
            </div>
            {tp == "join" && (
              <div className="func">
                <img
                  src={`${
                    process.env.PUBLIC_URL
                  }/images/icon/icon-next-arrow.svg`}
                />
              </div>
            )}
            {tp == "club" && (
              <div className="func">
                <Chip label="가입" color="primary" />
              </div>
            )}
          </div>
          <div className="date-wrap">
            <div className="date">
              {item.optgTp == "1" ? (
                <>기간제한 없음</>
              ) : (
                <>
                  {(checkDday(item.optgEndYmd) >0) ? (<>
                    CLOSE
                  </>) : isDday(item.optgStrtYmd) ? (
                    <>
                      기간
                      <span>
                        {moment(item.optgStrtYmd).format("MM.DD")} ~{" "}
                        {moment(item.optgEndYmd).format("MM.DD")}
                      </span>
                    </>
                  ) : (
                    <div className="date">COMMING SOON</div>
                  )}
                </>
              )}
            </div>
            <div className="dday">
              {item.optgTp == "2" && (checkDday(item.optgEndYmd) <= 0) ? (
                <>{getDday(item.optgStrtYmd, item.optgEndYmd)}</>
              ): (<></>)}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
